module.exports = __webpack_public_path__ + "assets/img/follow_gzh_tips.c8aa5031.png";